import { Component } from '@angular/core';

/**
 * LoaderComponent displays a universal loader when the response is
 * being fetched by the chat streaming API and will be hidden once the 
 * streaming response begins.
 */

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.css']
})
export class LoaderComponent {}
